<div class="row">
  @if (controls.stayVisaType; as stayVisaType) {
    <div class="standard-form-field widened-field stayVisaType-field required-field">
      <label for="stayVisaTypeInput" [class.invalid]="stayVisaType.touched && stayVisaType.invalid">
        {{ 'PERSONAL_DATA_FORM.STAY-VISA-TYPE.MAIN-LABEL' | translate }}
        <span aria-hidden="true">&nbsp;*</span>
        <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
      </label>
      <mat-form-field appearance="outline">
        <mat-select
          id="stayVisaTypeInput"
          panelClass="standard-select"
          [formControl]="stayVisaType"
          placeholder="{{ 'PERSONAL_DATA_FORM.STAY-VISA-TYPE.PLACEHOLDER' | translate }}"
          [attr.aria-required]="true"
          [attr.aria-invalid]="stayVisaType.touched && stayVisaType.invalid ? 'true' : null"
          [attr.aria-describedby]="stayVisaType.touched && stayVisaType.invalid ? 'stayVisaTypeError' : null">
          @for (item of visaTypes; track item) {
            <mat-option [value]="item">
              {{ 'COMMON.VISA_TYPES.' + item | translate }}
            </mat-option>
          }
        </mat-select>
        @if (stayVisaType.touched && stayVisaType.invalid) {
          <mat-error id="stayVisaTypeError">
            {{ stayVisaType.errors | errorsFormatingAndTranslate }}
          </mat-error>
        }
      </mat-form-field>
    </div>
  }
  @if (controls.stayVisaSeries; as stayVisaSeries) {
    <div class="standard-form-field stayVisaSeries-field required-field">
      <label for="stayVisaSeriesInput" [class.invalid]="stayVisaSeries.touched && stayVisaSeries.invalid">
        {{ 'PERSONAL_DATA_FORM.STAY-VISA-SERIES.MAIN-LABEL' | translate }}
        <span aria-hidden="true">&nbsp;*</span>
        <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
      </label>
      <mat-form-field appearance="outline">
        <input
          matInput
          id="stayVisaSeriesInput"
          type="text"
          maxLength="100"
          placeholder="{{ 'PERSONAL_DATA_FORM.STAY-VISA-SERIES.PLACEHOLDER' | translate }}"
          [formControl]="stayVisaSeries"
          [attr.aria-required]="true"
          [attr.aria-invalid]="stayVisaSeries.touched && stayVisaSeries.invalid ? 'true' : null"
          [attr.aria-describedby]="stayVisaSeries.touched && stayVisaSeries.invalid ? 'stayVisaSeriesError' : null" />
        @if (stayVisaSeries.touched && stayVisaSeries.invalid) {
          <mat-error id="stayVisaSeriesError">
            {{ stayVisaSeries.errors | errorsFormatingAndTranslate }}
          </mat-error>
        }
      </mat-form-field>
    </div>
  }
  @if (controls.stayVisaNumber; as stayVisaNumber) {
    <div class="standard-form-field stayVisaNumber-field required-field">
      <label for="stayVisaNumberInput" [class.invalid]="stayVisaNumber.touched && stayVisaNumber.invalid">
        {{ 'PERSONAL_DATA_FORM.STAY-VISA-NUMBER.MAIN-LABEL' | translate }}
        <span aria-hidden="true">&nbsp;*</span>
        <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
      </label>
      <mat-form-field appearance="outline">
        <input
          matInput
          id="stayVisaNumberInput"
          type="text"
          maxLength="100"
          placeholder="{{ 'PERSONAL_DATA_FORM.STAY-VISA-NUMBER.PLACEHOLDER' | translate }}"
          [formControl]="stayVisaNumber"
          [attr.aria-required]="true"
          [attr.aria-invalid]="stayVisaNumber.touched && stayVisaNumber.invalid ? 'true' : null"
          [attr.aria-describedby]="stayVisaNumber.touched && stayVisaNumber.invalid ? 'stayVisaNumberError' : null" />
        @if (stayVisaNumber.touched && stayVisaNumber.invalid) {
          <mat-error id="stayVisaNumberError">
            {{ stayVisaNumber.errors | errorsFormatingAndTranslate }}
          </mat-error>
        }
      </mat-form-field>
    </div>
  }
  @if (controls.stayVisaIssueDate; as stayVisaIssueDate) {
    <div class="standard-form-field stayVisaIssueDate-field required-field">
      <label for="stayVisaIssueDateInput" [class.invalid]="stayVisaIssueDate.touched && stayVisaIssueDate.invalid">
        {{ 'PERSONAL_DATA_FORM.STAY-VISA-ISSUE-DATE.MAIN-LABEL' | translate }}
        <span aria-hidden="true">&nbsp;*</span>
        <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
      </label>
      <mat-form-field appearance="outline" (click)="stayVisaIssueDatePicker.open()">
        <input
          matInput
          (focus)="stayVisaIssueDatePicker.open()"
          id="stayVisaIssueDateInput"
          #applicantStayVisaIssueDate
          [matDatepicker]="stayVisaIssueDatePicker"
          placeholder="{{ 'PERSONAL_DATA_FORM.STAY-VISA-ISSUE-DATE.PLACEHOLDER' | translate }}"
          [min]="minValidDate"
          [max]="maxValidDate"
          [readonly]="true"
          [attr.aria-required]="true"
          [attr.aria-invalid]="stayVisaIssueDate.touched && stayVisaIssueDate.invalid ? 'true' : null"
          [attr.aria-describedby]="
            stayVisaIssueDate.touched && stayVisaIssueDate.invalid ? 'stayVisaIssueDateError' : null
          "
          [formControl]="stayVisaIssueDate" />
        <mat-datepicker-toggle
          matSuffix
          [for]="stayVisaIssueDatePicker"
          aria-label="{{ 'COMMON.ACTION.OPEN_DATE_PICKER' | translate }}">
        </mat-datepicker-toggle>
        <mat-datepicker
          #stayVisaIssueDatePicker
          [startView]="'month'"
          [startAt]="stayVisaIssueDate.value || documentIssuePickerStartDate"
          (closed)="applicantStayVisaIssueDate.blur()">
        </mat-datepicker>
        @if (stayVisaIssueDate.touched && stayVisaIssueDate.invalid) {
          <mat-error id="stayVisaIssueDateError">
            {{ stayVisaIssueDate.errors | errorsFormatingAndTranslate }}
          </mat-error>
        }
      </mat-form-field>
    </div>
  }
  @if (controls.stayVisaExpiryDate; as stayVisaExpiryDate) {
    <div class="standard-form-field stayVisaExpiryDate-field required-field">
      <label for="stayVisaExpiryDateInput" [class.invalid]="stayVisaExpiryDate.touched && stayVisaExpiryDate.invalid">
        {{ 'PERSONAL_DATA_FORM.STAY-VISA-EXPIRY-DATE.MAIN-LABEL' | translate }}
        <span aria-hidden="true">&nbsp;*</span>
        <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
      </label>
      <mat-form-field appearance="outline" (click)="stayVisaExpiryDatePicker.open()">
        <input
          matInput
          (focus)="stayVisaExpiryDatePicker.open()"
          id="stayVisaExpiryDateInput"
          #applicantStayVisaExpiryDate
          [matDatepicker]="stayVisaExpiryDatePicker"
          placeholder="{{ 'PERSONAL_DATA_FORM.STAY-VISA-EXPIRY-DATE.PLACEHOLDER' | translate }}"
          [min]="minValidDate"
          [max]="maxValidFutureDate"
          [readonly]="true"
          [attr.aria-required]="true"
          [attr.aria-invalid]="stayVisaExpiryDate.touched && stayVisaExpiryDate.invalid ? 'true' : null"
          [attr.aria-describedby]="
            stayVisaExpiryDate.touched && stayVisaExpiryDate.invalid ? 'stayVisaExpiryDateError' : null
          "
          [formControl]="stayVisaExpiryDate" />
        <mat-datepicker-toggle
          matSuffix
          [for]="stayVisaExpiryDatePicker"
          aria-label="{{ 'COMMON.ACTION.OPEN_DATE_PICKER' | translate }}">
        </mat-datepicker-toggle>
        <mat-datepicker
          #stayVisaExpiryDatePicker
          [startView]="'month'"
          [startAt]="stayVisaExpiryDate.value || documentExpiryPickerStartDate"
          (closed)="applicantStayVisaExpiryDate.blur()">
        </mat-datepicker>
        @if (stayVisaExpiryDate.touched && stayVisaExpiryDate.invalid) {
          <mat-error id="stayVisaExpiryDateError">
            {{ stayVisaExpiryDate.errors | errorsFormatingAndTranslate }}
          </mat-error>
        }
      </mat-form-field>
    </div>
  }
  @if (controls.stayVisaPeriodOfStay; as stayVisaPeriodOfStay) {
    <div class="standard-form-field stayVisaPeriodOfStay-field required-field">
      <label
        for="stayVisaPeriodOfStayInput"
        [class.invalid]="stayVisaPeriodOfStay.touched && stayVisaPeriodOfStay.invalid">
        {{ 'PERSONAL_DATA_FORM.STAY-VISA-PERIOD-OF-STAY.MAIN-LABEL' | translate }}
        <span aria-hidden="true">&nbsp;*</span>
        <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
      </label>
      <mat-form-field appearance="outline">
        <input
          matInput
          id="stayVisaPeriodOfStayInput"
          type="number"
          min="1"
          max="9999"
          placeholder="{{ 'PERSONAL_DATA_FORM.STAY-VISA-PERIOD-OF-STAY.PLACEHOLDER' | translate }}"
          [formControl]="stayVisaPeriodOfStay"
          [attr.aria-required]="true"
          [attr.aria-invalid]="stayVisaPeriodOfStay.touched && stayVisaPeriodOfStay.invalid ? 'true' : null"
          [attr.aria-describedby]="
            stayVisaPeriodOfStay.touched && stayVisaPeriodOfStay.invalid ? 'stayVisaPeriodOfStayError' : null
          " />
        @if (stayVisaPeriodOfStay.touched && stayVisaPeriodOfStay.invalid) {
          <mat-error id="stayVisaPeriodOfStayError">
            {{ stayVisaPeriodOfStay.errors | errorsFormatingAndTranslate }}
          </mat-error>
        }
      </mat-form-field>
    </div>
  }
  @if (controls.stayVisaIssuingAuthority; as stayVisaIssuingAuthority) {
    <div class="standard-form-field stayVisaIssuingAuthority-field required-field">
      <label
        for="stayVisaIssuingAuthorityInput"
        [class.invalid]="stayVisaIssuingAuthority.touched && stayVisaIssuingAuthority.invalid">
        {{ 'PERSONAL_DATA_FORM.STAY-VISA-ISSUING-AUTHORITY.MAIN-LABEL' | translate }}
        <span aria-hidden="true">&nbsp;*</span>
        <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
      </label>
      <mat-form-field appearance="outline">
        <input
          matInput
          id="stayVisaIssuingAuthorityInput"
          type="text"
          minlength="1"
          maxlength="100"
          placeholder="{{ 'PERSONAL_DATA_FORM.STAY-VISA-ISSUING-AUTHORITY.PLACEHOLDER' | translate }}"
          [formControl]="stayVisaIssuingAuthority"
          [attr.aria-required]="true"
          [attr.aria-invalid]="stayVisaIssuingAuthority.touched && stayVisaIssuingAuthority.invalid ? 'true' : null"
          [attr.aria-describedby]="
            stayVisaIssuingAuthority.touched && stayVisaIssuingAuthority.invalid
              ? 'stayVisaIssuingAuthorityError'
              : null
          " />
        @if (stayVisaIssuingAuthority.touched && stayVisaIssuingAuthority.invalid) {
          <mat-error id="stayVisaIssuingAuthorityError">
            {{ stayVisaIssuingAuthority.errors | errorsFormatingAndTranslate }}
          </mat-error>
        }
      </mat-form-field>
    </div>
  }
</div>
